import { useState, useContext } from "react";
import ReactApexChart from "react-apexcharts";
import AlertsComp from "../../Components/AlertsComp";
import { formatDateToMMDDYYYY, origin } from "../../JS/Common";
import useConfig from "../../Hooks/useConfig";

export function TicketBySchool(props) {
  const { organization, hover_type } = useConfig();
  const [Alerts, setAlerts] = useState('');
  const vData = props.schooldata || [];
  const series = [{
    data: vData.map(item => ({
      x: item.school,
      y: item.tickets,
      amount: item.amount
    }))
  }];
  const labels = vData.map(item => item.school);
  const chartHeight = Math.max(300, vData.length * 20);
  const options = {
    chart: {
      type: 'bar',
      toolbar: {
        show: false,
      }
    },
    plotOptions: {
      bar: {
        borderRadius: 0,
        horizontal: true,
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val, { seriesIndex, dataPointIndex, w }) {
        const totalAmount = w.config.series[seriesIndex].data[dataPointIndex].amount;
        return val + " - $" + totalAmount;
      },
    },
    xaxis: {
      categories: labels,
      labels: {
        show: true,
        style: {
          fontSize: '12px',
        }
      }
    },
    colors: ['var(--primary-color)'],
    states: {
      hover: {
        filter: {
          type: hover_type
        }
      }
    },
    tooltip: {
      y: {
        formatter: function (val, { series, seriesIndex, dataPointIndex, w }) {
          const totalAmount = w.config.series[seriesIndex].data[dataPointIndex].amount;
          return "Total Tickets : " + val + "<br/>Amount: $" + totalAmount;
        },
        title: {
          formatter: function (seriesName, val) {
            return "";
          }
        }
      }

    }
  };
  const DownloadReport = () => {
    const csvContent = [];
    const gradeMap = new Map();


    // Add headers once
    csvContent.push([`${organization} Name`, 'Signup Date', 'Total Tickets Created (Selected Period)', 'Amount']);

    vData?.forEach((ticket, i) => {
      const grade = ticket.school || 'Unknown';
      if (!gradeMap.has(grade)) {
        gradeMap.set(grade, []);
      }
      const rowData = {
        [`${organization} Name`]: ticket?.school,
        'Account Creation Date': ticket.account_created_at ? formatDateToMMDDYYYY(ticket.account_created_at) : '-',
        'Total Tickets Created (Selected Period)': ticket?.tickets,
        'Amount': '$' + ticket?.amount
      };
      gradeMap.get(grade).push(rowData);
    });

    gradeMap.forEach((gradeData) => {
      gradeData.forEach((rowData) => {
        const values = Object.values(rowData).map(value => {
          if (typeof value == 'string' && value.includes(',')) {
            return `"${value}"`;
          }
          return value;
        });
        csvContent.push(values);
      });
    });

    if (csvContent.length > 1) { // Check if there is data (excluding headers)
      const csvString = csvContent.map(row => row.join(',')).join('\n');
      const blob = new Blob([csvString], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'TicketsCreated.csv';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      setAlerts(<AlertsComp show={true} variant="danger" msg={'No data available for download.'} />);
      setTimeout(function () {
        setAlerts(<AlertsComp show={false} />)
      }, 2500);
    }
  };

  return (
    <>
      {Alerts}
      <div className="col-12 text-center  greyBoxShadow" style={{ height: "100%", borderRadius: "10px", backgroundColor: "white" }}>
        <div className="w-100">
          <h4>Tickets Distribution by {organization}</h4>
          <u className="cursor-pointer" onClick={(e) => DownloadReport()}>Download Report</u>
          <ReactApexChart options={options} series={series} type="bar" height={chartHeight} />
        </div>
      </div >
    </>

  );
}